import { LANG } from '../i18n';

export const useLanguage = () => {
  const systemLanguage = navigator.language;
  let sysLanguage =
    systemLanguage === 'en'
      ? LANG.enUS
      : systemLanguage === 'zh-CN'
        ? LANG.zhCN
        : systemLanguage === 'zh-TW'
          ? LANG.zhTW
          : LANG.vi;
  return sysLanguage;
};
